<template>
    <div class="watchlist-banner">
        <div class="watchlist-banner__content">
            <span class="watchlist-banner__title" v-html="$t('WatchListUpgradedCollectionsBanner.title')"></span>
            <span class="watchlist-banner__description" v-html="$t('WatchListUpgradedCollectionsBanner.description')"></span>
        </div>
        <img :src="require('@/assets/images/learningpaths/learningpath_landingpage.png')" alt="" class="watchlist-banner__image"/>
        <span class="icon-cancel watchlist-banner__cancel" @click="closeBanner"></span>
    </div>
</template>

<script>
    export default {
        name: 'watchlist-upgraded-collection-banner',
        methods: {
            closeBanner () {
                window.localStorage.setItem('showWatchListUpgradedCollectionsBanner', false)
                this.$destroy()
                this.$el.parentNode.removeChild(this.$el)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .watchlist-banner {
        background: $champagne;
        padding: 20px 30px;
        display: flex;
        justify-content: space-between;
        border-radius: 10px;
        margin: 0 0 20px;

        &__content {
            display: flex;
            flex-direction: column;
            max-width: 1100px;
        }

        &__title {
            font-family: 'Quicksand-Regular', sans-serif;
            font-size: 2.4rem;
            margin: 0 0 20px;
        }

        &__description {
            font-size: 1.8rem;
            line-height: 2.5rem;
        }

        &__image {
            height: 120px;
            margin: 0 0 -20px
        }

        &__cancel {
            align-self: center;
            font-size: 2.8rem;
        }
    }
</style>
